@if (spinnerService.loading) {
  <app-spinner />
}

<app-toasts aria-live="polite" aria-atomic="true"></app-toasts>

<router-outlet />
